import { useEffect, useState } from 'react';
import { MRT_SortingState } from '@talentmesh/table';
import { useIdentifiedListContext } from './IdentifiedListContext';
import { IdentifiedProfileOptions } from '../../../api/useIdentifiedProfiles';

const useManualSorting = () => {
    const { setOptions } = useIdentifiedListContext();
    const state = useState<MRT_SortingState>([]);
    const [sorting] = state;

    useEffect(() => {
        if (sorting) {
            setOptions((p) => ({ ...p, sortBy: sorting[0] as IdentifiedProfileOptions['sortBy'] }));
        }
    }, [sorting, setOptions]);

    return state;
};

export default useManualSorting;
